import { render, staticRenderFns } from "./oss-uploadcover.vue?vue&type=template&id=0cd2aa54&scoped=true"
import script from "./oss-uploadcover.vue?vue&type=script&lang=js"
export * from "./oss-uploadcover.vue?vue&type=script&lang=js"
import style0 from "./oss-uploadcover.vue?vue&type=style&index=0&id=0cd2aa54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2aa54",
  null
  
)

export default component.exports